/**
 * 获取当前浏览器语言
 */
import queryString from '../core/query-string'
import { getCookie } from '@/utils/tool'

export const getLocalLanguage = function () {
  // modify: 优先读取链接中的lang参数，若没有再从 2020-10-20
  // 先去store中找，没有则取当前浏览器语言
  // 先去cookie中找语言，没有则取当前浏览器语言
  let query = location.search
  if (query && query !== '') {
    query = query.substring(1, query.length)
  }
  query = queryString.parse(query, '&')
  let language = query.lang || query.language || getCookie('_cpl')
  // let language = store.state.user.language;
  if (!language || language == '') {
    language = (navigator.language || navigator.browserLanguage).toLowerCase()
    language = language == null || language == '' ? 'en' : language
  }
  return language.toLowerCase()
}

export const hasChinese = function (str) {
  return /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/.test(str)
}

export const hasWest = function (str) {
  return /[a-z|[A-Z]|[/\d]/.test(str)
}

/* 从老的php代码搬运，用来判断姓名是否是西方姓名 */
export function isWest(str) {
  if (!str) return false
  let r = true
  if (str.charCodeAt(0) > 255) {
    r = false
  }
  return r
}
